/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ page: NonNullable<unknown> }} Task_Requirement_Go_ToInputs */

const en_task_requirement_go_to = /** @type {(inputs: Task_Requirement_Go_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Go to ${i?.page}`)
};

const pt_br2_task_requirement_go_to = /** @type {(inputs: Task_Requirement_Go_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ir para ${i?.page}`)
};

/**
* | output |
* | --- |
* | "Go to {page}" |
*
* @param {Task_Requirement_Go_ToInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_requirement_go_to = /** @type {((inputs: Task_Requirement_Go_ToInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Requirement_Go_ToInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_requirement_go_to(inputs)
	return pt_br2_task_requirement_go_to(inputs)
});